// API

import { setupAxiosInterceptors } from "./axiosConfig";
import api from "./api/Main";
import exporterApi from "./api/Exporter";
import importerApi from "./api/Importer";
import leadApi from "./api/Lead";
import verificationApi from "./api/Verification";

const apis = [api, exporterApi, importerApi, leadApi, verificationApi];
apis.forEach((api) => setupAxiosInterceptors(api));
// Export

export { api, exporterApi, importerApi, leadApi, verificationApi };
export default api;
